import React, { FC } from 'react'
import {
  Box,
  Typography,
  Card,
  CardContent,
  CardActionArea,
  useTheme,
} from '@mui/material'
import Grid from '@mui/material/Grid'
import DashboardIcon from '@mui/icons-material/Dashboard'
import SettingsIcon from '@mui/icons-material/Settings'
import { useNavigate } from 'react-router-dom'
import { BackButton } from '../../../../components/molecules/BackButton'
import { LogoutButton } from '../../../../components/organisms/LogoutButton'

export const TMNPortalHomePage: FC = () => {
  const navigate = useNavigate()
  const theme = useTheme()

  const portalItems = [
    {
      title: 'OCR処理設定',
      description: 'CSV保存タイミングやQR直接読み取り設定を管理できます',
      icon: (
        <SettingsIcon sx={{ fontSize: 48, color: theme.palette.grey[500] }} />
      ),
      path: '/portal/ocr-settings',
    },
  ]

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: theme.palette.grey[50],
        py: 4,
        px: { xs: 2, sm: 4 },
      }}
    >
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 1,
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 'bold',
              color: theme.palette.primary.dark,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <DashboardIcon sx={{ fontSize: 32 }} />
            管理ポータル
          </Typography>
        </Box>

        <Typography
          variant="body1"
          sx={{
            mb: 4,
            color: theme.palette.text.secondary,
            textAlign: 'center',
          }}
        ></Typography>

        <Grid container spacing={3} sx={{ mt: 2 }}>
          {portalItems.map((item, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <Card
                sx={{
                  height: '100%',
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: theme.shadows[8],
                  },
                }}
              >
                <CardActionArea
                  onClick={() => navigate(item.path)}
                  sx={{
                    height: '100%',
                    p: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}
                >
                  <CardContent sx={{ flex: 1, width: '100%' }}>
                    <Box sx={{ mb: 2 }}>{item.icon}</Box>
                    <Typography
                      variant="h6"
                      component="h2"
                      sx={{
                        mb: 2,
                        fontWeight: 'bold',
                        color: theme.palette.text.primary,
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: theme.palette.text.secondary,
                        lineHeight: 1.6,
                      }}
                    >
                      {item.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      <BackButton text="処方箋画面へ戻る" onClick={() => navigate('/')} />

      <LogoutButton />
    </Box>
  )
}
